import { navigate } from 'gatsby';
import React, { useEffect } from 'react';

import { paths } from '@/constants/paths';
import { useProtectedPage } from '@/hooks/useProtectedPage';

export const RouteGuard = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    const go500 = () => navigate(paths.internalServerError);

    window.addEventListener('app:server-error', go500);

    return () => {
      window.removeEventListener('app:server-error', go500);
    };
  }, []);

  useEffect(() => {
    const go500 = () => navigate(paths.internalServerError);

    window.addEventListener('app:offline', go500);

    return () => {
      window.removeEventListener('app:offline', go500);
    };
  }, []);

  useEffect(() => {
    const home = () => navigate(paths.home);

    window.addEventListener('app:no-authetication', home);

    return () => {
      window.removeEventListener('app:no-authetication', home);
    };
  }, []);

  useEffect(() => {
    const home = () => navigate(paths.home);

    window.addEventListener('app:forbidden', home);

    return () => {
      window.removeEventListener('app:forbidden', home);
    };
  }, []);

  useProtectedPage();

  return <>{children}</>;
};
